<div class="home__designtemplates__container" appLazyViewport (inViewport)="loadTemplates()">
  <!-- Header: Left-aligned with brand orange accent bar + Pill Tabs + View all -->
  <div class="designtemplates__header">
    <div class="designtemplates__heading">
      <h2 class="designtemplates__header-title">{{ 'home.templates.title' | translate }}</h2>
    </div>

    <!-- Filter Tabs -->
    <div class="designtemplates__tabs" *ngIf="!isLoading && !hasError">
      <button
        type="button"
        class="tab-btn"
        [class.active]="activeTab === 'all'"
        (click)="setTab('all')"
      >
        {{ 'home.templates.tab_all' | translate }}
      </button>
      <button
        type="button"
        class="tab-btn"
        [class.active]="activeTab === 'free'"
        (click)="setTab('free')"
      >
        {{ 'home.templates.tab_free' | translate }}
      </button>
      <button
        type="button"
        class="tab-btn"
        [class.active]="activeTab === 'paid'"
        (click)="setTab('paid')"
      >
        {{ 'home.templates.tab_paid' | translate }}
      </button>
    </div>

    <a
      routerLink="/product"
      [queryParams]="{ personalize: true }"
      class="designtemplates__header-link"
    >
      {{ 'common.view_all' | translate }}
      <span class="material-symbols-outlined" aria-hidden="true">arrow_forward</span>
    </a>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <p>{{ 'common.loading' | translate }}...</p>
  </div>

  <!-- Error State -->
  <app-section-error
    *ngIf="!isLoading && hasError"
    (retry)="loadTemplates()"
  >
  </app-section-error>

  <!-- Content Grid -->
  <div *ngIf="!isLoading && !hasError">
    <div class="designtemplates__grid" *ngIf="currentTemplates.length > 0">
      <div 
        class="designtemplates__item" 
        *ngFor="let template of currentTemplates"
        (click)="onSelectTemplate(template)"
      >
        <div class="template-image-wrapper">
          <img
            *ngIf="!brokenImageIds.has(template.id)"
            [appLazyImg]="getTemplateImageUrl(template)"
            (imageError)="onImageError(template.id)"
            [alt]="template.name"
          />
          <div *ngIf="brokenImageIds.has(template.id)" class="template-image-fallback" aria-hidden="true">
            <span class="material-symbols-outlined">palette</span>
            <span class="fallback-name" *ngIf="template.name">{{ template.name }}</span>
          </div>
        </div>
        
        <!-- Badge: Miễn phí hoặc Giá -->
        <div class="template-badge">
          <span class="badge badge-free" *ngIf="isFree(template)">
            <span class="material-symbols-outlined icon">redeem</span>
            {{ 'home.templates.free_badge' | translate }}
          </span>
          <span class="badge badge-paid" *ngIf="!isFree(template)">
            <span class="material-symbols-outlined icon">loyalty</span>
            {{ template.price ? (template.price | number:'1.0-0') : 0 }}đ
          </span>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="designtemplates__empty" *ngIf="currentTemplates.length === 0">
      <span class="material-symbols-outlined empty-icon">palette</span>
      <p>{{ 'home.templates.empty' | translate }}</p>
    </div>
  </div>

  <!-- Bottom CTA for mobile screens -->
  <div class="designtemplates__bottom">
    <a
      routerLink="/product"
      [queryParams]="{ personalize: true }"
      class="designtemplates__view-all"
    >
      {{ 'home.templates.action_btn' | translate }}
      <span class="material-symbols-outlined" aria-hidden="true">arrow_right_alt</span>
    </a>
  </div>
</div>